import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Поможем подобрать \nфинансовый продукт',
  subtitle: 'Закажите звонок и наш менеджер перезвонит вам',
  form: {
    name: {
      label: 'Ваше имя',
    },
    phone: {
      label: 'Введите ваш телефон',
    },
    date: {
      label: 'Выберите день звонка',
      value: 'Сегодня ({date})',
    },
    time: {
      label: 'Время по МСК',
    },
    actions: {
      submit: 'Заказать звонок',
    },
    errors: {
      require: 'Обязательное поле',
      maxLength: 'Максимальная длина поля {length} символов',
    },
    requiredInfo: '* Обязательное поле',
    agreement: {
      text: 'Даю {agreement} на обработку своих персональных данных в соответствии c {policy}',
      agreement: 'Согласие',
      policy: 'Политикой обработки персональных данных',
    },
    daysOfWeek: {
      monday: 'Понедельник',
      tuesday: 'Вторник',
      wednesday: 'Среда',
      thursday: 'Четверг',
      friday: 'Пятница',
      saturday: 'Суббота',
      sunday: 'Воскресенье',
    },
  },
} as const satisfies TMessages
